"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getProductUrl = require("./getProductUrl");
Object.keys(_getProductUrl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getProductUrl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getProductUrl[key];
    }
  });
});
var _mapProductShadesQuery = require("./mapProductShadesQuery");
Object.keys(_mapProductShadesQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapProductShadesQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapProductShadesQuery[key];
    }
  });
});
var _shouldFetchShades = require("./shouldFetchShades");
Object.keys(_shouldFetchShades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _shouldFetchShades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shouldFetchShades[key];
    }
  });
});
